import { gql } from "@apollo/client";

const UpdateGameMutation = gql`
mutation UpdateGame ($id: ID! $round: Int $dateStart: AWSDateTime) {
  updateGame1 (input: {
    id : $id
    RoundCurrent : $round
    DateStart : $dateStart
  }) {
    id
    RoundTotal
    RoundCurrent
    DateStart
    QuestionSet
    Player_1
    Player_1_Score
    Player_1_DisplayName
    Player_1_Round
    Player_2
    Player_2_Score
    Player_2_DisplayName
    Player_2_Round
    Player_3
    Player_3_Score
    Player_3_DisplayName
    Player_3_Round
    Player_4
    Player_4_Score
    Player_4_DisplayName
    Player_4_Round
  }
  }
`;

export default UpdateGameMutation